//5. Create a Note.jsx component to show a <div> element with a
//<h1> for a title and a <p> for the content.
//6. Make sure that the final website is styled like the example shown here:
//https://l1pp6.csb.app/

//HINT: You will need to study the classes in teh styles.css file to appy styling.
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";
// import Note from "./components/Note";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <App />
);